import script from "./PopupSing.vue?vue&type=script&setup=true&lang=js"
export * from "./PopupSing.vue?vue&type=script&setup=true&lang=js"

import "./PopupSing.vue?vue&type=style&index=0&id=d5b34450&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d5b34450"]])

export default __exports__